import { SET_HEADER_SEARCH_VISIBILITY } from '../../mutation-types';

export function show({ commit }) {
    commit(SET_HEADER_SEARCH_VISIBILITY, { isVisible: true });
}

export function hide({ commit }) {
    commit(SET_HEADER_SEARCH_VISIBILITY, { isVisible: false });
}

export function toggle({ commit, state }) {
    commit(SET_HEADER_SEARCH_VISIBILITY, { isVisible: !state.isVisible });
}
